import type { IController, material } from 'angular';
import type { PrintingService } from '../../Print/printing.service';
import type { ExportConfig } from '../../Print/export-dialog/export-dialog.component';
import type { I18n } from '../../i18n/mx-internationalization';
import type { Dashboard } from '../dashboard.service';

export class DashboardExportWizardController implements IController {
	downloading = false;
	config?: ExportConfig;
	dashboard!: Dashboard;
	title = '';

	static readonly $inject = ['$mdDialog', 'mx.sb.Printing.PrintingService', 'mx.internationalization'];
	constructor(
		private readonly $mdDialog: material.IDialogService,
		private readonly printingService: PrintingService,
		private readonly i18n: I18n
	) {}

	$onInit() {
		this.title = this.i18n.getFormatted('shell.dashboards.downloadDashboard', this.dashboard.title);
	}

	handleConfigChange(config: ExportConfig) {
		this.config = config;
	}

	async confirm() {
		if (!this.config) {
			return;
		}
		this.downloading = true;
		switch (this.config.type) {
			case 'pdf':
				await this.printingService.loadPDF(this.config.contentNode, this.dashboard.title, this.config.orientation, this.config.headerNode, this.config.footerNode);
				break;
			case 'png':
			case 'jpeg':
				await this.printingService.loadImage(
					this.config.contentNode,
					this.config.type,
					this.dashboard.title,
					this.config.width,
					this.config.headerNode,
					this.config.footerNode
				);
				break;
		}

		this.downloading = false;
		this.$mdDialog.hide();
	}

	cancel() {
		this.$mdDialog.cancel();
	}
}
